import { render, staticRenderFns } from "./ProposalNetworksRouterView.vue?vue&type=template&id=6141be6b&"
import script from "./ProposalNetworksRouterView.vue?vue&type=script&lang=js&"
export * from "./ProposalNetworksRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports